/// <reference path="../../app.definition.ts" />


function dateRange() {
    return function (items, startDate, endDate) {
        //an undefined startDate is converted to the beginning of time
        startDate = startDate || 0;
        let retVals = [];
        const granularity = null // can be 'days', ... see momentJS doc

        retVals = items.filter(item => moment(item.date).isBetween(startDate, endDate, granularity, '[]'));
        //
        // console.log("filtering based on date [start:"+startDate+"][end:"+endDate+"] : ", retVals);
        return retVals;
    }

}

angular.module('eCareVault.common.filters').filter('dateRange', dateRange);
